(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /*
   * Three behaviours on one scroll listener:
   *
   *  - scrolling down past the header's own height hides it, so it stops
   *    overlapping the headings it passes over;
   *  - any upward scroll brings it straight back, so navigation is a flick
   *    away from anywhere on the page;
   *  - on a page with a hero behind it, the transparent treatment lasts only
   *    while the hero is still under the header. Past that it goes solid.
   *
   * The hero's height is read from the element rather than assumed, and
   * re-read on resize, since it is sized in viewport units.
   */
  class SiteHeader {
    constructor() {
      this.header = document.querySelector('[data-site-header]');
      if (!this.header) return;

      this.transparent = this.header.hasAttribute('data-header-transparent');
      this.hero = document.querySelector('.hero');
      this.lastY = window.scrollY;
      this.ticking = false;

      this.measure();
      this.update();

      window.addEventListener('scroll', () => this.request(), { passive: true });
      window.addEventListener('resize', () => {
        this.measure();
        this.update();
      });
    }

    measure() {
      // Past this point the hero no longer sits behind the header.
      this.heroEnd = this.hero ? this.hero.offsetHeight - this.header.offsetHeight : 0;
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const y = Math.max(0, window.scrollY);
      const goingDown = y > this.lastY;

      // Held open across the top of the page so it never hides on a bounce.
      const clearOfTop = y > this.header.offsetHeight;
      this.header.classList.toggle('site-header--hidden', goingDown && clearOfTop);

      if (this.transparent) {
        this.header.classList.toggle('site-header--over-hero', y < this.heroEnd);
      }

      this.lastY = y;
    }
  }

  new SiteHeader();

  /*
   * The compact header's menu sheet. A modal <dialog>, so focus is held
   * inside and Escape closes it for free. Following any link or Cart inside
   * it closes the sheet first; the cart drawer's own document listener then
   * opens the drawer over the page. Widening past the compact breakpoint
   * closes it too, since its toggle is no longer there to close it with.
   */
  class SiteMenu {
    constructor() {
      this.dialog = document.querySelector('[data-site-menu]');
      if (!this.dialog) return;

      document.querySelectorAll('[data-menu-open]').forEach((button) => {
        button.addEventListener('click', () => {
          this.dialog.showModal();
          this.dialog.focus();
        });
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target.closest('[data-menu-close], a')) this.dialog.close();
      });

      window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
        if (event.matches) this.dialog.close();
      });
    }
  }

  new SiteMenu();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /*
   * Drives the gallery strip: the arrows scroll it one shot over, and the
   * counter and arrow state follow wherever it comes to rest.
   *
   * The strip's scroll position is the only state. Swipes, arrow clicks and
   * keyboard scrolling all move it, so reading the current shot back from
   * scrollLeft keeps every input in agreement without tracking them apart.
   */
  class ProductGallery {
    constructor() {
      this.gallery = document.querySelector('[data-product-gallery]');
      if (!this.gallery) return;

      this.track = this.gallery.querySelector('[data-product-track]');
      this.prev = this.gallery.querySelector('[data-product-prev]');
      this.next = this.gallery.querySelector('[data-product-next]');
      this.output = this.gallery.querySelector('[data-product-counter-current]');
      if (!this.track || !this.prev || !this.next || !this.output) return;

      this.shots = Array.from(this.track.querySelectorAll('[data-product-shot]'));
      if (this.shots.length < 2) return;

      this.current = -1;
      this.ticking = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: no-preference)');

      this.prev.addEventListener('click', () => this.go(this.current - 1));
      this.next.addEventListener('click', () => this.go(this.current + 1));
      this.track.addEventListener('scroll', () => this.request(), { passive: true });

      this.update();
    }

    go(index) {
      const target = Math.max(0, Math.min(index, this.shots.length - 1));
      this.track.scrollTo({
        left: target * this.track.clientWidth,
        behavior: this.motion.matches ? 'smooth' : 'auto',
      });
    }

    request() {
      if (this.ticking) return;
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (index === this.current) return;

      this.current = index;
      this.output.textContent = index + 1;

      const focused = document.activeElement;
      this.prev.disabled = index === 0;
      this.next.disabled = index === this.shots.length - 1;

      /* An arrow that fades out under focus hands it to the one still shown. */
      if (focused === this.prev && this.prev.disabled) this.next.focus();
      if (focused === this.next && this.next.disabled) this.prev.focus();
    }
  }

  new ProductGallery();

  /*
   * A video plays only while most of its shot is on screen, so one swiped or
   * scrolled away pauses, and one never reached downloads nothing past its
   * poster. The strip clips its overflow, so a shot off to the side counts as
   * out of view just like one below the fold.
   */
  const productVideos = document.querySelectorAll('[data-product-video]');
  if (productVideos.length) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) {
            target.play().catch(() => {});
          } else {
            target.pause();
          }
        });
      },
      { threshold: 0.6 }
    );
    productVideos.forEach((video) => videoObserver.observe(video));
  }

  } catch(e) { console.error(e); }
})();
})();
